import historyManager from 'components/history-manager';
import { foreach, makeUrl } from 'components/utils';
import { activateFilterToggle, activateFilterTextfield } from 'components/search-page-functions';
import $ from 'jquery';
import 'components/fengyuanchen_datepicker';
import 'components/agenda-calendar';
import { hideReadSpeaker } from './components/utils';

let searchHandler = null;
let params = historyManager.getUrlParams();

/**
 * Initiates / starts the search: loads results based on the filters from the backend
 */
function initSearch(params, page = 0, allPages = false) {
    showLoader();
    checkTGBubbleHighlight();
    if (searchHandler) {
        searchHandler.abort();
        searchHandler = null;
    }
    // clear result content on first page:
    if (page === 0) {
        resultContainer.html('');
    }
    let shadowParams = Object.assign({}, params);
    shadowParams.page = page;
    shadowParams.allPages = allPages;
    searchHandler = $.get(makeUrl('/agenda/search'), shadowParams)
        .done((res) => {
            resultContainer.append(res);
        })
        .always(() => {
            searchHandler = null;
            hideLoader();
            hideReadSpeaker();
        });
}

/**
 * shows a loading indicator. resultcontainer must be a jquery object.
 */
function showLoader(resultcontainer) {
    loaderContainer.html('<div class="searching"></div>');
}

/**
 * hides a loading indicator. resultcontainer must be a jquery object.
 */
function hideLoader(resultcontainer) {
    loaderContainer.html('');
}

const resultContainer = $('#searchresult-container');
const loaderContainer = $('#loader-container');

// Init all filter elements that listen for user click / history changes:
let filterLinks = document.querySelectorAll(
    'a[data-filter],li[data-filter],input[data-filter][type=checkbox],polygon[data-filter],rect[data-filter]',
);
let filterTextfields = document.querySelectorAll('input[data-filter][type=search]');

foreach(filterLinks, activateFilterToggle);
foreach(filterTextfields, activateFilterTextfield);

// Set the date field values manually from the browser history
$('#dateFrom').val(params.dateRangeFrom || null);
$('#dateTo').val(params.dateRangeTo || null);

historyManager.history.listen((location, action) => {
    let params = historyManager.getUrlParams();
    let actualPage = Number(params.page) || 0;
    initSearch(params, actualPage);
});

// **************************************************
// Date selection toggling:
// Either show the Calendar, or show the date selection,
// or show none of it (if special date selections are selected, like 'today')
// selector can be either 'days' (calendar), 'dateName' (special dates), 'dateRange' (date selection)
function toggleDateSelectionComponents(selector) {
    switch (selector) {
        case 'dateRange':
            $('#kalenderToggle').removeClass('active');
            $('.kalender').hide();
            $('#zeitraumToggle').addClass('active');
            $('.zeitraum').show();
            break;
        case 'dateName':
            $('#kalenderToggle').removeClass('active');
            $('.kalender').hide();
            $('#zeitraumToggle').removeClass('active');
            $('.zeitraum').hide();
            break;
        default:
            $('#kalenderToggle').addClass('active');
            $('.kalender').show();
            $('#zeitraumToggle').removeClass('active');
            $('.zeitraum').hide();
    }
}
$('#kalenderToggle').on('click', function (e) {
    let params = historyManager.getUrlParams();
    delete params.dateName;
    delete params.dateRangeFrom;
    delete params.dateRangeTo;
    historyManager.pushParams(params);
    toggleDateSelectionComponents('days');
});
$('#zeitraumToggle').on('click', function (e) {
    let params = historyManager.getUrlParams();
    delete params.dateName;
    delete params.days;
    historyManager.pushParams(params);
    toggleDateSelectionComponents('dateRange');
});
$('[data-filter=dateName]').on('click', function (e) {
    let params = historyManager.getUrlParams();
    delete params.days;
    delete params.dateRangeFrom;
    delete params.dateRangeTo;
    historyManager.pushParams(params);
    toggleDateSelectionComponents('dateName');
});

// Manages the date selection components according to the (url) params given:
// Those params come from historyManager.getUrlParams, normally.
function manageDateSelectionComponentsByUrlparams(params) {
    if (params.days) {
        toggleDateSelectionComponents('days');
    } else if (params.dateName) {
        toggleDateSelectionComponents('dateName');
    } else if (params.dateRangeFrom || params.dateRangeTo) {
        toggleDateSelectionComponents('dateRange');
    } else {
        // default
        toggleDateSelectionComponents('days');
    }
}

// we listen on history changes and show/hide date selection elements
// if they appear in the history:
historyManager.history.listen((location, action) => {
    let params = historyManager.getUrlParams();
    manageDateSelectionComponentsByUrlparams(params);
});

// Initial startup: select date components by url params
manageDateSelectionComponentsByUrlparams(historyManager.getUrlParams());
// End Date selection toggling
// **************************************************

// search Date btn: search by date range
$('#searchDateRange').on('click', (e) => {
    let params = historyManager.getUrlParams();
    let dateFrom = String($('#dateFrom').val());
    let dateTo = String($('#dateTo').val());
    delete params.dateRangeFrom;
    delete params.dateRangeTo;
    if (dateFrom.length > 0) {
        params.dateRangeFrom = dateFrom;
    }
    if (dateTo.length > 0) {
        params.dateRangeTo = dateTo;
    }

    historyManager.pushParams(params);
});

// Clear all filters listener: removes all filters:
$('#reset,input[type=reset]').on('click', (e) => {
    historyManager.pushParams({});
    // to settle the original map clicks first, wait a bit
    setTimeout(checkTGBubbleHighlight, 10);
});

// more button
$('#moreBtn').on('click', (e) => {
    let params = historyManager.getUrlParams();
    params.page = (Number(params.page) || 0) + 1;
    historyManager.pushParams(params, false);
});

// Stream-Button: de-select map filter when stream filter is enabled:
$('[name=streams]').on('click', (e) => {
    let params = historyManager.getUrlParams();
    if (params.streams) {
        // params.region = [];
        delete params.region;
    }
    historyManager.pushParams(params, true);
});

/** ---------------------- Map buttons handling ------------------------------- */
// Region-TG-Button
let tgRegions = ['frauenfeld', 'kreuzlingen', 'weinfelden', 'arbon', 'muenchwilen'];
$('#region-tg').on('click', (e) => {
    let params = historyManager.getUrlParams();
    params.region = tgRegions;
    historyManager.pushParams(params);
    setTimeout(checkTGBubbleHighlight, 10);
});
$('#region-extern').on('click', (e) => {
    let params = historyManager.getUrlParams();
    params.region = ['extern'];
    historyManager.pushParams(params);
});

// On each click on an SVG Map Part, we need to check if all "TG" region is selected,
// to also toggle the TG button (See #13813):
$('[data-filter=region]').on('click', (e) => {
    // to settle the original map clicks first, wait a bit
    setTimeout(checkTGBubbleHighlight, 10);
});

let checkTGBubbleHighlight = function () {
    let selected = historyManager.getUrlParams().region;
    if (!(selected instanceof Array)) {
        selected = [selected];
    }
    // Check if the selected regions are all selected: hightlight
    // the TG button if, else deselect:
    let all = true;
    for (let i = 0; i < tgRegions.length; i++) {
        if (selected.indexOf(tgRegions[i]) === -1) {
            all = false;
            break;
        }
    }
    if (all) {
        $('#region-tg').addClass('active');
    } else {
        $('#region-tg').removeClass('active');
    }
};

/** ---------------------- END Map buttons handling ------------------------------- */

/** ---------------------- filter accept mobile - some special handling for non-standard fields: */
$('.filteracceptmobile,button.searchsubmit').on('click', (e) => {
    // Emulate key / click events on the original elements:
    let keyEvt = new Event('keypress');
    keyEvt.keyCode = 13;

    let params = historyManager.getUrlParams();
    let queryField = $('[data-filter=query]');
    if (queryField.val() && queryField.val() !== params.query) {
        queryField[0].dispatchEvent(keyEvt);
    }

    $('#searchDateRange').trigger('click');
});
/** ------------------------------------------------------------------------------*/

// ------------ Initialize Date Picker: ----------------
// // @see components/fengyuanchen_datepicker.js for defaults / global settings
$('input.datepicker').datepicker();

// start first initial search
// See #13314: All TG regions must be selected by default:
(() => {
    if (Object.keys(params).length === 0) {
        historyManager.pushParams({ region: tgRegions });
    } else {
        initSearch(params, Number(params.page) || 0, true);
    }
})();

/** ------------------------------ Initial Filter container open --------------------------*/
/** Containers that have active filter params set are set to open on page load */
(() => {
    let params = historyManager.getUrlParams();
    Object.keys(params).forEach((key) => {
        let selector = `[data-filter-container*=${key}]`;
        $(selector).addClass('open');
    });
})();
